var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaycomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 93.52 93.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.87,
    x2: 93.39,
    y1: 19.46,
    y2: 87.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3cf60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#008f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006242"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M87.73 9.4H16.85a6 6 0 0 0-6 6v81.53a6 6 0 0 0 6 6h12.59a6 6 0 0 0 6-6v-57a6 6 0 0 1 6-6h32.43a6 6 0 0 1 6 6v32.4a6 6 0 0 1-6 6H55.18a6 6 0 0 0-6 6v12.53a6 6 0 0 0 6 6h43.24a6 6 0 0 0 6-6V15.37a6 6 0 0 0-6-6z",
    transform: "translate(-10.88 -9.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaycomLogo);
export default __webpack_public_path__ + "static/media/paycomLogo.a2030c30766702bae9a994423d59d310.svg";
export { ForwardRef as ReactComponent };